/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Available_Share_Codes_LabelInputs */



/**
* | output |
* | --- |
* | "Available share codes" |
*
* @param {Team_Share_Available_Share_Codes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_available_share_codes_label = /** @type {((inputs?: Team_Share_Available_Share_Codes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Available_Share_Codes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Codes de partage disponibles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfügbare Freigabecodes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codici di condivisione disponibili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступные коды акций")
	if (locale === "es") return /** @type {LocalizedString} */ ("Códigos de acciones disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("可用的股票代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能な共有コード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपलब्ध शेयर कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Códigos de compartilhamento disponíveis")
	return /** @type {LocalizedString} */ ("Available share codes")
});